import { api } from "@/shared/api/client";
import { PageHistoryGetDTO, HistoryQueryFilter } from "@/shared/types/admin";

export const historyService = {
    getAll: async (params: {
        page: number;
        size: number;
        filter?: HistoryQueryFilter;
    }): Promise<PageHistoryGetDTO> => {
        const response = await api.get<PageHistoryGetDTO>("/histories", {
            params: {
                "pageable.page": params.page - 1,
                "pageable.size": params.size,
                "filter.username": params.filter?.username,
                "filter.date": params.filter?.date,
            },
        });
        return response.data;
    },
};
